<template>
  <v-card class="h-auto" :style="{ borderRadius: '16px' }">
    <div class="h-20 sm:h-36">
      <div
        style="
          position: relative;
          width: 100%;
          height: 140px;
          border-radius: 16px 16px 0 0;
          background-color: #e0e0e0;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        "
      >
        <v-img
          v-if="
            business_data &&
            business_data.business_banner_url &&
            business_data.business_banner_url.length > 0
          "
          :src="path_file(business_data.business_banner_url)"
          class="w-full"
          :style="{ borderRadius: '16px 16px 0 0' }"
          :height="140"
        ></v-img>
        <div v-else>
          <v-icon style="font-size: 48px; color: grey"> mdi-domain </v-icon>
        </div>
      </div>
    </div>
    <v-row no-gutters class="pa-6 justify-center text-center text-sm-left">
      <v-col cols="12" sm="auto">
        <v-avatar
          :size="$vuetify.breakpoint.xsOnly ? '150px' : '150px'"
          :color="
            business_data && business_data.business_logo_url ? 'white' : 'grey'
          "
          class="elevation-4"
        >
          <v-img
            v-if="business_data && business_data.business_logo_url"
            alt="Avatar"
            :src="path_file(businessLogoUrl)"
            contain
          />
          <v-icon
            v-else
            dark
            :style="
              $vuetify.breakpoint.xsOnly
                ? 'font-size: 30px;'
                : 'font-size: 45px;'
            "
            >mdi-domain</v-icon
          >
        </v-avatar>
      </v-col>
      <v-col class="pl-sm-4 justify-center py-4">
        <div class="font-bold text-header pb-2">
          {{ business_data?.business_name_th }}
        </div>
        <div v-if="theme !== 'TCC_EDUCATION_ADMIN'" class="font-normal text-sm sm:text-lg pb-2">
          <span v-if="business_data?.business_sector_th">{{
            business_data?.business_sector_th
          }}</span>
          <span
            class="mx-1"
            v-if="
              business_data?.business_sector_th &&
              business_data?.business_type_name_th
            "
            >|</span
          >
          <span v-if="business_data?.business_type_name_th">
            {{ business_data?.business_type_name_th }}
          </span>
        </div>
        <v-row v-if="theme !== 'TCC_EDUCATION_ADMIN'" class="align-center">
          <v-col cols="12" sm="auto">
            <div class="text-center">
              <v-icon class="text-theme-text_red h-5 w-5"
                >mdi-map-marker-outline</v-icon
              >
              <template
                v-if="
                  business_data?.district_name || business_data?.province_name
                "
              >
                {{ business_data?.district_name }}
                <span v-if="business_data?.district_name">,</span>
                {{ business_data?.province_name }}
              </template>
              <template v-else>{{ $t("extra.notSpecified") }}</template>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="auto" class="edit-button pt-2 pt-sm-6">
        <v-btn
          outlined
          rounded
          color="default_button_primary"
          @click="goToEditBusinessProfile"
        >
          <span v-if="refCode === 'moph'">แก้ไขข้อมูลโปรไฟล์หน่วยบริการ</span>
          <span v-else>{{ $t("busiP.btn.edit") }}</span>
          <v-icon class="pl-1" color="default_button_primary">
            mdi-pencil-outline
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      refCode: localStorage.getItem("refcode") || null,
      theme: process.env.VUE_APP_USE_THEME,
    };
  },
  props: {
    business_data: {},
  },
  computed: {
    businessLogoUrl() {
      if (this.business_data?.refcode === "moph") {
        return "logo_MOPH.png";
      }
      return this.business_data?.business_logo_url || "wlc_logo_tab.png";
    },
  },
  methods: {
    path_file(file) {
      if (typeof file == "string") {
        return file;
      } else if (file == null || file == "") {
        return null;
      } else {
        return URL.createObjectURL(file);
      }
    },
    goToEditBusinessProfile() {
      this.$router.push("/business_profile/edit_business_profile");
    },
  },
};
</script>

<style scoped>
.opacity-50 {
  opacity: 0.5;
}
.text-header {
  font-size: 28px;
}
.font-bold {
  font-weight: bold;
}
.font-normal {
  font-weight: normal;
}
.text-theme-text_default {
  color: #333333;
}
.text-theme-text_red {
  color: #ff0000;
}
.text-theme-secondary_light {
  color: #007bff;
}

.edit-button {
  display: flex;
  justify-content: center;
}
</style>
